export const PROFILES = {

  // ── 1. ÉDUCATION / FORMATION ──────────────────────────────────────────────
  education: {
    id:          'education',
    label:       'École & Formation',
    description: 'Établissements, CFA, organismes de formation',
    icon:        '🎓',
    accentColor: 'orange',

    layout: {
      homeModule:   'dashboard',
      sidebarOrder: ['dashboard', 'inscriptions', 'protocoles', 'cohortes', 'crm', 'contact', 'personnel', 'branding', 'stats', 'modération'],
      modules: {
        dashboard:  { icon: 'LayoutDashboard', label: 'Tableau de Bord',        source: 'dashboard',  renderMode: 'cosmetic'                           },
        inscriptions:     { icon: 'Users',           label: 'Apprenants',        source: 'inscriptions',     renderMode: 'cosmetic'                           },
        protocoles:   { icon: 'BookOpen',        label: 'Protocoles',          source: 'protocoles',   renderMode: 'cosmetic'                           },
        cohortes:   { icon: 'Grid',            label: 'Cohortes',          source: 'cohortes',   renderMode: 'cosmetic'                           },
        crm:        { icon: 'Kanban',          label: 'CRM',               source: 'crm',        renderMode: 'specialized', component: 'CRMPanel' },
        contact:    { icon: 'MessageSquare',   label: 'Messagerie',        source: 'contact',    renderMode: 'cosmetic'                           },
        personnel:  { icon: 'UserCheck',       label: 'Formateurs',        source: 'personnel',  renderMode: 'cosmetic'                           },
        branding:   { icon: 'Palette',         label: 'Branding',          source: 'branding',   renderMode: 'cosmetic'                           },
        stats:      { icon: 'BarChart',        label: 'Statistiques',      source: 'stats',      renderMode: 'cosmetic'                           },
        modération: { icon: 'Shield',          label: 'Modération',        source: 'modération', renderMode: 'cosmetic'                           },
      },
    },

    vocabulary: {
      learners:        'Apprenants',
      learner:         'Apprenant',
      courses:         'Parcours',
      course:          'Parcours',
      cohortes:        'Cohortes',
      cohorte:         'Cohorte',
      staff:           'Formateurs',
      staffMember:     'Formateur',
      enroll:          'Inscrire',
      complete:        'Terminer',
      progress:        'Progression',
      sectionLearners: 'APPRENANTS',
      sectionCourses:  'PARCOURS',
      sectionCohortes: "COHORTES",
      sectionStaff:    'FORMATEURS',
      sectionCRM:      'CRM',
      contact:         'Prospect',
      contacts:        'Prospects',
      pipeline:        "Pipeline d'inscriptions",
      deal:            "Dossier d'admission",
      company:         'Établissement',
    },

    kpis: {
      total:      'Apprenants total',
      active:     'Actifs',
      revenue:    'Pesas circulants',
      completion: 'Taux de complétion',
    },

    crmConfig: {
      pipelineStages: [
        { id: 'prospect', label: 'Prospect', color: 'zinc',    icon: '👀' },
        { id: 'candidat', label: 'Candidat', color: 'sky',     icon: '📋' },
        { id: 'inscrit',  label: 'Inscrit',  color: 'amber',   icon: '✍️' },
        { id: 'actif',    label: 'Actif',    color: 'emerald', icon: '🎯' },
        { id: 'diplome',  label: 'Diplômé',  color: 'purple',  icon: '🏆' },
        { id: 'perdu',    label: 'Perdu',    color: 'red',     icon: '✗'  },
      ],
      contactFields: ['nom', 'email', 'telephone', 'etablissement', 'protocoles_interesse', 'budget'],
      scoreLabel:    "Score d'admission",
      noteLabel:     'Note de suivi',
    },

    sections: {
      dashboard: true, contact: true, protocoles: true, inscriptions: true,
      cohortes: true, personnel: true, branding: true, stats: true,
      modération: true, crm: true,
    },
  },

  // ── 2. ENTREPRISE / CORPORATE / SAAS ─────────────────────────────────────
  corporate: {
    id:          'corporate',
    label:       'Entreprise & Corporate',
    description: 'RH, L&D interne, SaaS, industrie, formation équipes',
    icon:        '🏛️',
    accentColor: 'sky',

    layout: {
      homeModule:   'protocoles',
      sidebarOrder: ['dashboard', 'inscriptions', 'protocoles', 'cohortes', 'crm', 'contact', 'personnel', 'stats', 'branding', 'modération'],
      modules: {
        dashboard:  { icon: 'LayoutDashboard', label: 'Dashboard',        source: 'dashboard',  renderMode: 'cosmetic'                           },
        inscriptions:     { icon: 'Users',           label: 'Collaborateurs',    source: 'inscriptions',     renderMode: 'cosmetic'                           },
        protocoles:   { icon: 'BookOpen',        label: 'Programmes',        source: 'protocoles',   renderMode: 'cosmetic'                           },
        cohortes:   { icon: 'Grid',            label: 'Cohorte',           source: 'cohortes',   renderMode: 'cosmetic'                           },
        crm:        { icon: 'Kanban',          label: 'CRM',               source: 'crm',        renderMode: 'specialized', component: 'CRMCorporatePanel' },
        contact:    { icon: 'MessageSquare',   label: 'Messagerie',        source: 'contact',    renderMode: 'cosmetic'                           },
        personnel:  { icon: 'UserCheck',       label: 'Equipe',          source: 'personnel',  renderMode: 'cosmetic'                           },
        stats:      { icon: 'BarChart',        label: 'Analytics',         source: 'stats',      renderMode: 'cosmetic'                           },
        branding:   { icon: 'Palette',         label: 'Marque',            source: 'branding',   renderMode: 'cosmetic'                           },
        modération: { icon: 'Shield',          label: 'Conformité',        source: 'modération', renderMode: 'cosmetic'                           },
      },
    },

    vocabulary: {
      learners:        'Collaborateurs',
      learner:         'Collaborateur',
      courses:         'Programmes',
      course:          'Programme',
      cohortes:        'Équipes',
      cohorte:         'Équipe',
      staff:           'Managers',
      staffMember:     'Manager',
      enroll:          'Affecter',
      complete:        'Valider',
      progress:        'Progression',
      sectionLearners: 'COLLABORATEURS',
      sectionCourses:  'PROGRAMMES',
      sectionCohortes: 'ÉQUIPES',
      sectionStaff:    'MANAGERS',
      sectionCRM:      'CRM',
      contact:         'Lead',
      contacts:        'Leads',
      pipeline:        'Pipeline de vente',
      deal:            'Opportunité',
      company:         'Compte',
    },

    kpis: {
      total:      'Collaborateurs total',
      active:     'Actifs',
      revenue:    'MRR',
      completion: "Taux d'activation",
    },

    crmConfig: {
      pipelineStages: [
        { id: 'lead',      label: 'Lead',          color: 'zinc',    icon: '📡' },
        { id: 'qualified', label: 'Qualifié',       color: 'sky',     icon: '🔍' },
        { id: 'demo',      label: 'Démo planifiée', color: 'amber',   icon: '📅' },
        { id: 'trial',     label: 'En essai',       color: 'purple',  icon: '⚗️' },
        { id: 'closed',    label: 'Client',         color: 'emerald', icon: '✅' },
        { id: 'churned',   label: 'Churné',         color: 'red',     icon: '↩️'  },
      ],
      contactFields: ['nom', 'email', 'entreprise', 'taille_equipe', 'plan_interesse', 'arr_estime'],
      scoreLabel:    'Lead Score',
      noteLabel:     'Notes de qualification',
    },

    sections: {
      dashboard: true, contact: true, protocoles: true, inscriptions: true,
      cohortes: true, personnel: true, branding: true, stats: true,
      modération: true, crm: true,
    },
  },

  // ── 3. CRÉATION / MÉDIA ───────────────────────────────────────────────────
  creative: {
    id:          'creative',
    label:       'Création & Média',
    description: 'Agences, studios, freelances, production audiovisuelle',
    icon:        '🎬',
    accentColor: 'fuchsia',

    layout: {
      homeModule:   'contacts',
      sidebarOrder: ['dashboard', 'contacts', 'projets', 'profils', 'collectifs', 'portfolio', 'staff', 'messagerie', 'stats', 'modération'],
      modules: {
        dashboard:  { icon: 'LayoutDashboard', label: 'Dashboard',  source: 'dashboard',  renderMode: 'cosmetic'                                        },
        contacts:   { icon: 'Kanban',          label: 'Suivi',      source: 'crm',        renderMode: 'specialized', component: 'CRMCreativePanel'       },
        projets:    { icon: 'FolderKanban',    label: 'Projets',    source: 'protocoles',   renderMode: 'specialized', component: 'CreativeProjectPanel'    },
        profils:    { icon: 'User',            label: 'Profils',    source: 'inscriptions',     renderMode: 'cosmetic'                                        },
        collectifs: { icon: 'Users',           label: 'Collectifs', source: 'cohortes',   renderMode: 'cosmetic'                                        },
        portfolio:  { icon: 'Image',           label: 'Portfolio',  source: 'portfolio',  renderMode: 'specialized', component: 'CreativePortfolioPanel'  },
        staff:      { icon: 'UserCheck',       label: 'Équipe',     source: 'personnel',  renderMode: 'cosmetic'                                        },
        messagerie: { icon: 'MessageSquare',   label: 'Messagerie', source: 'contact',    renderMode: 'cosmetic'                                        },
        stats:      { icon: 'BarChart',        label: 'Métriques',  source: 'stats',      renderMode: 'cosmetic'                                        },
        modération: { icon: 'Shield',          label: 'Modération', source: 'modération', renderMode: 'cosmetic'                                        },
      },
    },

    vocabulary: {
      learners:        'Talents',
      learner:         'Talent',
      courses:         'Projets',
      course:          'Projet',
      cohortes:        'Collectifs',
      cohorte:         'Collectif',
      staff:           'Équipe interne',
      staffMember:     'Collaborateur',
      enroll:          'Engager',
      complete:        'Livrer',
      progress:        'Avancement',
      sectionLearners: 'TALENTS',
      sectionCourses:  'PROJETS',
      sectionCohortes: 'COLLECTIFS',
      sectionStaff:    'ÉQUIPE',
      sectionCRM:      'SUIVI',
      contact:         'Contact',
      contacts:        'Contacts',
      pipeline:        'Pipeline de production',
      deal:            'Projet signé',
      company:         'Structure',
    },

    kpis: {
      total:      'Talents suivis',
      active:     'Projets en cours',
      revenue:    'CA généré',
      completion: 'Taux de livraison',
    },

    crmConfig: {
      pipelineStages: [
        { id: 'prospect',    label: 'Prospect',      color: 'zinc',    icon: '👀' },
        { id: 'brief',       label: 'Brief reçu',    color: 'sky',     icon: '📋' },
        { id: 'negociation', label: 'Négociation',   color: 'amber',   icon: '🤝' },
        { id: 'production',  label: 'En production', color: 'fuchsia', icon: '🎬' },
        { id: 'livre',       label: 'Livré',         color: 'emerald', icon: '✅' },
        { id: 'perdu',       label: 'Perdu',         color: 'red',     icon: '✗'  },
      ],
      contactFields: ['nom', 'prenom', 'email', 'telephone', 'type_contact', 'specialite', 'portfolio_url', 'budget_estime'],
      scoreLabel:    'Potentiel créatif',
      noteLabel:     'Note de casting / relation',
    },

    sections: {
      dashboard: true, contact: true, protocoles: true, inscriptions: true,
      cohortes: true, personnel: true, branding: true, stats: true,
      modération: true, crm: true,
    },
  },

  // ── 4. SANTÉ / MÉDICAL ────────────────────────────────────────────────────
  health: {
    id:          'health',
    label:       'Santé & Médical',
    description: 'Cliniques, cabinets, formation médicale continue, CHU',
    icon:        '🏥',
    accentColor: 'emerald',

    layout: {
      homeModule:   'dashboard',
      sidebarOrder: ['dashboard', 'patients', 'protocoles', 'services', 'crm', 'contact', 'praticiens', 'stats', 'branding', 'modération'],
      modules: {
        dashboard:  { icon: 'LayoutDashboard', label: 'Dashboard',           source: 'dashboard',  renderMode: 'cosmetic'                           },
        patients:   { icon: 'Users',           label: 'Patients / Apprenants',source: 'inscriptions',     renderMode: 'cosmetic'                           },
        protocoles: { icon: 'BookOpen',        label: 'Protocoles',          source: 'protocoles',   renderMode: 'cosmetic'                           },
        services:   { icon: 'Grid',            label: 'Services / Unités',   source: 'cohortes',   renderMode: 'cosmetic'                           },
        crm:        { icon: 'Kanban',          label: 'Suivi patients',      source: 'crm',        renderMode: 'specialized', component: 'CRMPanel' },
        contact:    { icon: 'MessageSquare',   label: 'Messagerie',          source: 'contact',    renderMode: 'cosmetic'                           },
        praticiens: { icon: 'UserCheck',       label: 'Praticiens',          source: 'personnel',  renderMode: 'cosmetic'                           },
        stats:      { icon: 'BarChart',        label: 'Épidémiologie',       source: 'stats',      renderMode: 'cosmetic'                           },
        branding:   { icon: 'Palette',         label: 'Communication',       source: 'branding',   renderMode: 'cosmetic'                           },
        modération: { icon: 'Shield',          label: 'Conformité / RGPD',   source: 'modération', renderMode: 'cosmetic'                           },
      },
    },

    vocabulary: {
      learners:        'Patients',
      learner:         'Patient',
      courses:         'Protocoles',
      course:          'Protocole',
      cohortes:        'Services',
      cohorte:         'Service',
      staff:           'Praticiens',
      staffMember:     'Praticien',
      enroll:          'Admettre',
      complete:        'Clôturer',
      progress:        'Suivi',
      sectionLearners: 'PATIENTS',
      sectionCourses:  'PROTOCOLES',
      sectionCohortes: 'SERVICES',
      sectionStaff:    'PRATICIENS',
      sectionCRM:      'SUIVI PATIENTS',
      contact:         'Référent',
      contacts:        'Référents',
      pipeline:        'Parcours de soins',
      deal:            'Dossier patient',
      company:         'Établissement',
    },

    kpis: {
      total:      'Patients suivis',
      active:     'En cours de soin',
      revenue:    'Actes réalisés',
      completion: 'Taux de clôture',
    },

    crmConfig: {
      pipelineStages: [
        { id: 'admission',  label: 'Admission',        color: 'zinc',    icon: '📋' },
        { id: 'diagnostic', label: 'Diagnostic',       color: 'sky',     icon: '🔬' },
        { id: 'traitement', label: 'Traitement',       color: 'amber',   icon: '💊' },
        { id: 'suivi',      label: 'Suivi post-soins', color: 'purple',  icon: '📊' },
        { id: 'cloture',    label: 'Clôturé',          color: 'emerald', icon: '✅' },
        { id: 'perdu',      label: 'Perdu de vue',     color: 'red',     icon: '⚠️' },
      ],
      contactFields: ['nom', 'prenom', 'email', 'telephone', 'date_naissance', 'medecin_referent', 'pathologie'],
      scoreLabel:    'Score de criticité',
      noteLabel:     'Observation clinique',
    },

    sections: {
      dashboard: true, contact: true, protocoles: true, inscriptions: true,
      cohortes: true, personnel: true, branding: true, stats: true,
      modération: true, crm: true,
    },
  },

  // ── 5. CONSEIL / SERVICES ─────────────────────────────────────────────────
  consulting: {
    id:          'consulting',
    label:       'Conseil & Services',
    description: 'Cabinets, ESN, freelances B2B, accompagnement',
    icon:        '💼',
    accentColor: 'purple',

    layout: {
      homeModule:   'crm',
      sidebarOrder: ['crm', 'dashboard', 'clients', 'missions', 'equipes', 'contact', 'consultants', 'stats', 'branding', 'modération'],
      modules: {
        crm:         { icon: 'Kanban',          label: 'Pipeline',         source: 'crm',        renderMode: 'specialized', component: 'CRMPanel' },
        dashboard:   { icon: 'LayoutDashboard', label: 'Dashboard',        source: 'dashboard',  renderMode: 'cosmetic'                           },
        clients:     { icon: 'Users',           label: 'Clients',          source: 'inscriptions',     renderMode: 'cosmetic'                           },
        missions:    { icon: 'BookOpen',        label: 'Missions',         source: 'protocoles',   renderMode: 'cosmetic'                           },
        equipes:     { icon: 'Grid',            label: 'Équipes projet',   source: 'cohortes',   renderMode: 'cosmetic'                           },
        contact:     { icon: 'MessageSquare',   label: 'Messagerie',       source: 'contact',    renderMode: 'cosmetic'                           },
        consultants: { icon: 'UserCheck',       label: 'Consultants',      source: 'personnel',  renderMode: 'cosmetic'                           },
        stats:       { icon: 'BarChart',        label: 'Performance',      source: 'stats',      renderMode: 'cosmetic'                           },
        branding:    { icon: 'Palette',         label: 'Identité',         source: 'branding',   renderMode: 'cosmetic'                           },
        modération:  { icon: 'Shield',          label: 'Conformité',       source: 'modération', renderMode: 'cosmetic'                           },
      },
    },

    vocabulary: {
      learners:        'Clients',
      learner:         'Client',
      courses:         'Missions',
      course:          'Mission',
      cohortes:        'Équipes projet',
      cohorte:         'Équipe',
      staff:           'Consultants',
      staffMember:     'Consultant',
      enroll:          'Affecter',
      complete:        'Livrer',
      progress:        'Avancement',
      sectionLearners: 'CLIENTS',
      sectionCourses:  'MISSIONS',
      sectionCohortes: 'ÉQUIPES',
      sectionStaff:    'CONSULTANTS',
      sectionCRM:      'PIPELINE',
      contact:         'Contact',
      contacts:        'Contacts',
      pipeline:        'Pipeline commercial',
      deal:            'Affaire',
      company:         'Entreprise cliente',
    },

    kpis: {
      total:      'Clients total',
      active:     'Missions actives',
      revenue:    'CA en cours',
      completion: 'Taux de livraison',
    },

    crmConfig: {
      pipelineStages: [
        { id: 'identification', label: 'Identification', color: 'zinc',    icon: '🔎' },
        { id: 'qualification',  label: 'Qualification',  color: 'sky',     icon: '📊' },
        { id: 'proposition',    label: 'Proposition',    color: 'amber',   icon: '📄' },
        { id: 'negociation',    label: 'Négociation',    color: 'orange',  icon: '🤝' },
        { id: 'gagne',          label: 'Gagné',          color: 'emerald', icon: '🏆' },
        { id: 'perdu',          label: 'Perdu',          color: 'red',     icon: '✗'  },
      ],
      contactFields: ['nom', 'poste', 'email', 'entreprise', 'secteur', 'budget_mission'],
      scoreLabel:    'Score de maturité',
      noteLabel:     'Compte-rendu',
    },

    sections: {
      dashboard: true, contact: true, protocoles: true, inscriptions: true,
      cohortes: true, personnel: true, branding: true, stats: true,
      modération: true, crm: true,
    },
  },
};

export function getProfile(profileId) {
  return PROFILES[profileId] ?? PROFILES.education;
}

export const PROFILE_LIST = Object.values(PROFILES).map(
  ({ id, label, description, icon, accentColor }) => ({ id, label, description, icon, accentColor })
);

export function generateDemoContacts(profileId = 'education') {
  const profile = getProfile(profileId);
  const stages  = profile.crmConfig.pipelineStages;

  const templates = {
    education: [
      { nom: 'Martin',    prenom: 'Sophie',   email: 'sophie.martin@email.fr',   entreprise: 'Lycée Voltaire',       stage: stages[1]?.id, score: 78 },
      { nom: 'Dubois',    prenom: 'Lucas',    email: 'lucas.dubois@email.fr',    entreprise: 'Université Paris X',   stage: stages[0]?.id, score: 45 },
      { nom: 'Leroy',     prenom: 'Emma',     email: 'emma.leroy@email.fr',      entreprise: 'BTS Commerce',         stage: stages[2]?.id, score: 91 },
      { nom: 'Moreau',    prenom: 'Antoine',  email: 'a.moreau@email.fr',        entreprise: 'Indépendant',          stage: stages[3]?.id, score: 88 },
      { nom: 'Simon',     prenom: 'Chloé',    email: 'chloe.simon@email.fr',     entreprise: 'IUT Lyon',             stage: stages[4]?.id, score: 95 },
      { nom: 'Michel',    prenom: 'Pierre',   email: 'p.michel@email.fr',        entreprise: 'CFA Paris',            stage: stages[5]?.id, score: 22 },
    ],
    corporate: [
      { nom: 'Dupont',    prenom: 'Alice',    email: 'alice@techcorp.io',         entreprise: 'TechCorp SA',          stage: stages[2]?.id, score: 82 },
      { nom: 'Bernard',   prenom: 'Thomas',   email: 'thomas@startup.co',         entreprise: 'StartupCo',            stage: stages[1]?.id, score: 67 },
      { nom: 'Robert',    prenom: 'Marie',    email: 'marie@agency.fr',           entreprise: 'Agency Plus',          stage: stages[3]?.id, score: 74 },
      { nom: 'Richard',   prenom: 'Julien',   email: 'julien@telecom.fr',         entreprise: 'TelecomGroup',         stage: stages[4]?.id, score: 93 },
      { nom: 'Petit',     prenom: 'Léa',      email: 'lea@enterprise.com',        entreprise: 'Enterprise SA',        stage: stages[0]?.id, score: 38 },
      { nom: 'Garcia',    prenom: 'Marc',     email: 'marc@bigco.fr',             entreprise: 'BigCo Industries',     stage: stages[5]?.id, score: 15 },
    ],
    creative: [
      { nom: 'Beaumont',  prenom: 'Jade',     email: 'jade@studio.fr',            entreprise: 'Studio Pixel',         stage: stages[3]?.id, score: 85 },
      { nom: 'Renard',    prenom: 'Hugo',     email: 'hugo@agence.fr',            entreprise: 'Agence Lumière',       stage: stages[1]?.id, score: 70 },
      { nom: 'Mercier',   prenom: 'Inès',     email: 'ines@freelance.fr',         entreprise: '',                     stage: stages[2]?.id, score: 78 },
      { nom: 'Fontaine',  prenom: 'Alexis',   email: 'alexis@prod.fr',            entreprise: 'Prod & Co',            stage: stages[4]?.id, score: 92 },
      { nom: 'Chevalier', prenom: 'Clara',    email: 'clara@media.fr',            entreprise: 'Média Sud',            stage: stages[0]?.id, score: 44 },
      { nom: 'Gauthier',  prenom: 'Romain',   email: 'romain@lost.fr',            entreprise: '',                     stage: stages[5]?.id, score: 18 },
    ],
    health: [
      { nom: 'Leclerc',   prenom: 'Martine',  email: 'm.leclerc@chu.fr',          entreprise: 'CHU Bordeaux',         stage: stages[2]?.id, score: 80 },
      { nom: 'Vidal',     prenom: 'Damien',   email: 'd.vidal@clinique.fr',       entreprise: 'Clinique du Parc',     stage: stages[1]?.id, score: 65 },
      { nom: 'Perrin',    prenom: 'Sylvie',   email: 's.perrin@cabinet.fr',       entreprise: 'Cabinet Santé+',       stage: stages[3]?.id, score: 72 },
      { nom: 'Arnaud',    prenom: 'Nicolas',  email: 'n.arnaud@hopital.fr',       entreprise: 'Hôpital Lariboisière', stage: stages[0]?.id, score: 55 },
      { nom: 'Blanchard', prenom: 'Émilie',   email: 'e.blanchard@ssiad.fr',      entreprise: 'SSIAD Loire',          stage: stages[4]?.id, score: 90 },
      { nom: 'Roussel',   prenom: 'Frédéric', email: 'f.roussel@perdu.fr',        entreprise: '',                     stage: stages[5]?.id, score: 20 },
    ],
    consulting: [
      { nom: 'Lambert',   prenom: 'Caroline', email: 'c.lambert@cabinet.fr',      entreprise: 'Groupe Audit',         stage: stages[3]?.id, score: 85 },
      { nom: 'Fontaine',  prenom: 'Olivier',  email: 'o.fontaine@conseil.fr',     entreprise: 'Conseil & Co',         stage: stages[2]?.id, score: 71 },
      { nom: 'Rousseau',  prenom: 'Isabelle', email: 'i.rousseau@rh.fr',          entreprise: 'DRH Industrie',        stage: stages[1]?.id, score: 58 },
      { nom: 'Morel',     prenom: 'Stéphane', email: 's.morel@pme.fr',            entreprise: 'PME Locale',           stage: stages[4]?.id, score: 96 },
      { nom: 'Bonnet',    prenom: 'Nathalie', email: 'n.bonnet@finance.fr',       entreprise: 'Finance Corp',         stage: stages[0]?.id, score: 42 },
      { nom: 'Girard',    prenom: 'François', email: 'f.girard@lost.fr',          entreprise: 'Concurrent',           stage: stages[5]?.id, score: 20 },
    ],
  };

  const base = templates[profileId] ?? templates.education;
  return base.map((t, i) => ({
    _id:       `demo_${profileId}_${i}`,
    ...t,
    telephone: `06 ${String(10 + i * 7).padStart(2,'0')} ${String(20 + i * 3).padStart(2,'0')} ${String(30 + i * 11 % 100).padStart(2,'0')} ${String(40 + i * 17 % 100).padStart(2,'0')}`,
    tags:      [],
    notes:     [],
    createdAt: new Date(Date.now() - i * 86400000 * 3).toISOString(),
    updatedAt: new Date(Date.now() - i * 86400000).toISOString(),
  }));
}

export function resolveVocab(profile, token, fallback = token) {
  return profile?.vocabulary?.[token] ?? fallback;
}

export function buildSections(profile, baseSections = []) {
  const layout  = profile.layout;
  const modules = layout?.modules ?? {};
  const order   = layout?.sidebarOrder ?? baseSections.map(s => s.id);

  return order.map(id => {
    const mod  = modules[id];
    const base = baseSections.find(s => s.id === (mod?.source ?? id));
    return {
      id,
      label:      mod?.label      ?? base?.label  ?? id,
      icon:       mod?.icon       ?? base?.icon   ?? 'Circle',
      short:      base?.short     ?? id.slice(0, 3).toUpperCase(),
      color:      base?.color     ?? 'zinc',
      source:     mod?.source     ?? id,
      renderMode: mod?.renderMode ?? 'cosmetic',
      component:  mod?.component  ?? null,
    };
  });
}

export default PROFILES;